import type { Meta } from '@lib/api';
import { OWNER_WAREHOUSE } from '@lib/api/common';
import { locationTypeLabel } from '@locales/id/labels';

/**
 * The registration warehouse as the UI names it: always the type's label ("Gudang Pusat"), whatever the place itself
 * is called (one name for it on every screen). `meta` is kept for callers that pass it.
 */
export const warehouseLabel = (_meta?: Meta) => locationTypeLabel(OWNER_WAREHOUSE);
export const useWarehouseName = () => warehouseLabel();
